import React, {ReactNode} from "react"

import {RadioOptionRow, RadioIconContainer, RadioIcon} from "./styled"
import {Option, OptionRow} from "../Radio"

export interface CustomNodeOption extends Option {
  customNode?: ReactNode
}
export interface CustomNodeOptionRow extends OptionRow {
  option: CustomNodeOption
}

const customNodeRenderer = (customNodeOptionRow: CustomNodeOptionRow) => {
  const {
    checked,
    option: {customNode}
  } = customNodeOptionRow
  return (
    <RadioOptionRow>
      <RadioIconContainer>
        <RadioIcon checked={checked} />
      </RadioIconContainer>
      {customNode}
    </RadioOptionRow>
  )
}

export default customNodeRenderer
